import { Chart, registerables } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useEffect, useRef } from "react";

import { formatNumber } from "utils/formatNumber";

Chart.register(...registerables);

const formatData = ({ data, backgroundColor, barThickness } = {}) => {
  const labels = [];
  const values = [];
  data?.forEach((item) => {
    labels.push(item.label);
    values.push(item.value);
  });
  return {
    labels,
    datasets: [
      {
        data: values,
        backgroundColor,
        barThickness,
        datalabels: {
          anchor: "end",
          align: "end",
          formatter: function(value, context) {
            return formatNumber.toAmount(value);
          }
        },
      },
    ],
  };
};

const StackedBarChart = (props) => {
  const {
    data = [],
    height = 250,
    id = "bar-chart",
    barThickness = 12,
    borderRadius = 100,
    dataBgColor = "#FFB703",
  } = props;

  const chartRef = useRef(null);

  useEffect(() => {
    const createChart = (chartData) => {
      const ctx = document.getElementById(id)?.getContext("2d");
      chartRef.current = new Chart(ctx, {
        type: "bar",
        data: chartData,
        plugins: [ChartDataLabels],
        options: {
          responsive: true,
          maintainAspectRatio: false,
          elements: {
            bar: {
              borderRadius,
              borderSkipped: false,
            },
          },
          plugins: {
            legend: {
              display: false,
            },
          },
          scales: {
            x: {
              stacked: true,
              border: {
                color: "#ECECEC",
                width: 2,
              },
              grid: {
                drawOnChartArea: false,
                drawTicks: false,
              },
            },
            y: {
              grace: "30%",
              stacked: true,
              border: {
                color: "#ECECEC",
                width: 2,
              },
              position: "right",
              beginAtZero: true,
              ticks: {
                stepSize: 50,
                callback: (value) => {
                  return formatNumber.toAmount(value);
                },
              },
              grid: {
                lineWidth: 2,
                drawTicks: false,
              },
            },
          },
        },
      });
    };

    if (chartRef.current) {
      chartRef.current.destroy();
    }

    createChart(
      formatData({ data, backgroundColor: dataBgColor, barThickness }),
    );

    return () => {
      chartRef.current.destroy();
    };
  }, [barThickness, borderRadius, data, dataBgColor, id, height]);

  return (
    <div className='w-full'>
      <canvas id={id} width='400' height={height}></canvas>
    </div>
  );
};

export default StackedBarChart;
